import getParameterFromURL from './getParameterFromURL';
import steps from '../../survey/stepsV2';

/**
 * Универсальная функция для AB-теста с 2 или 3 вариантами.
 *
 * @param {number} count — количество вариантов (2 или 3)
 * @param {string} key — ключ в localStorage и имя события для трекинга
 * @param {...*} args — значения и вероятности:
 *    Для 2 вариантов: valueA, valueB, probabilityA, probabilityB
 *    Для 3 вариантов: valueA, valueB, valueC, probabilityA, probabilityB, probabilityC
 * @returns {*} — выбранное (или ранее сохранённое) значение
 */
function saveRandomValue(count, key, ...args) {
  console.log(key);
  const abTestType = key === 'p13_newPrices_p17_p18' || key === 'p20v1_paywall_redLabelDiscount_noSpecial'
    || key === 'p13_US_newPrices_p17_p18'
    ? 'payment_page'
    : 'onboarding';

  const stored = localStorage.getItem(key);

  if (stored !== null) {
    steps.analytics.send({
      event: {
        event: 'AB_TEST',
        ab_name: key,
        ab_group: stored,
        ab_test_type: abTestType,
      },
    });

    return `${key}_${stored}`;
  }

  let values; let 
    probabilities;

  if (count === 2) {
    // args: valueA, valueB, probabilityA, probabilityB
    values = args.slice(0, 2);
    probabilities = args.slice(2, 4);
  } else if (count === 3) {
    // args: valueA, valueB, valueC, probabilityA, probabilityB, probabilityC
    values = args.slice(0, 3);
    probabilities = args.slice(3, 6);
  } else {
    throw new Error('Поддерживается только 2 или 3 варианта');
  }

  // === Новый блок: переопределение значений из URL-параметров ===
  const overrideA = getParameterFromURL('AValue');
  const overrideB = getParameterFromURL('BValue');
  const overrideC = count === 3 ? getParameterFromURL('CValue') : null;

  if (window.location.hostname !== 'webapp.everydoggy.com') {
    if (overrideA != null) probabilities[0] = Number(overrideA);
    if (overrideB != null) probabilities[1] = Number(overrideB);
    if (count === 3 && overrideC != null) probabilities[2] = Number(overrideC);
  }
  
  // === /Новый блок ===
  const total = probabilities.reduce((sum, p) => sum + p, 0);
  if (Math.abs(total - 100) > 0.01) {
    if (count === 2) {
      probabilities[0] = 50;
      probabilities[1] = 50;
    }
    if (count === 3) {
      probabilities[0] = 40;
      probabilities[1] = 30;
      probabilities[2] = 30;
    }
  }
  console.log(probabilities);

  const r = Math.random() * 100;
  let cumulative = 0;
  let result;

  for (let i = 0; i < probabilities.length; i++) {
    cumulative += probabilities[i];
    if (r < cumulative) {
      result = values[i];
      break;
    }
  }

  steps.analytics.send({
    event: {
      event: 'AB_TEST',
      ab_name: key,
      ab_group: result,
      ab_test_type: abTestType,
    },
  });

  localStorage.setItem(key, result);

  return `${key}_${result}`;
}

export default saveRandomValue;
